import { useSelector } from "react-redux";
import { TRootState } from "../../store/create-store";
import ColumnUtils from "../../utils/ColumnUtils";
import styles from "./Meta.module.css";
import SectionTitle from "../../components/SectionTitle";
import Table, { TableCell } from "../../components/Table";
import withErrorBoundary from "../../hocs/withErrorBoundary";
import RowUtils from "../../utils/RowUtils";
import ColumnNameUtils from "../../utils/ColumnNameUtils";
import LabelTitle from "../../components/LabelTitle";
import { selectLeftPanelState, selectRootState } from "../../selectors";
import Typography from "../../components/Typography";

const Meta = () => {
  const { firstRow, metaColumns, selectedMethod } = useSelector(selectMeta);

  if (!selectedMethod) {
    return <>No method selected</>;
  }

  const metaColumnsForSelectedMethod = metaColumns.filter((column) =>
    ColumnNameUtils.isMetaForMethod(column, selectedMethod)
  );

  if (metaColumnsForSelectedMethod.length === 0) {
    return (
      <Typography variant="body">
        No meta data found for selected method
      </Typography>
    );
  }

  return (
    <div className={styles.wrapper}>
      {selectedMethod && (
        <LabelTitle>
          {ColumnNameUtils.removePrefixes(selectedMethod)}
        </LabelTitle>
      )}

      <SectionTitle>Meta data</SectionTitle>

      <Table>
        <tbody>
          {metaColumnsForSelectedMethod.map((column) => (
            <tr key={column}>
              <TableCell type="key">
                {ColumnUtils.getMetaLabel(column, selectedMethod)}
              </TableCell>

              <TableCell type="value">
                {RowUtils.getValue(firstRow, column)}
              </TableCell>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

const selectMeta = (state: TRootState) => {
  return {
    firstRow: selectRootState(state).rows[0],
    selectedMethod: selectLeftPanelState(state).selectedMethod,
    metaColumns: selectRootState(state).metaColumns,
  };
};

export default withErrorBoundary(Meta);
